import React, {  useState } from "react"

import useMediaQuery from "@material-ui/core/useMediaQuery"
import MuiDatables from "Components/UI/Atoms/Table"
import SetState from "Components/Hooks/SetState"
import { interfaces } from "service/interfaces"
import DateFilter from "Components/UI/Atoms/Table/DatePickerFilter"
import Tooltip from "@material-ui/core/Tooltip"
import { IconButton } from "@material-ui/core"
import EditContextProvider from "Components/Hooks/ContextEdit"
import DeleteIcon from "@material-ui/icons/Delete"

import AutocompleteFilter from "Components/UI/Atoms/Table/Autocomplete"
import moment from "moment"
import Edit from "./Edit"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import { ESTADO_VEH } from "Constants"

const WafersWithControlTable = (props) => {
  const { render, setRender, data, apiCall, setData } = props
  const windowSize = useMediaQuery("(min-width:1000px)")
  const [loading, setLoading] = useState(false)
  const { state, setOpen, setClose } = SetState()

  const createDismissableSnackbar = useCustomSnackbar()

  const {
    state: remove,
    setOpen: openRemove,
    setClose: closeRemove,
  } = SetState()

  async function vehInfo(id) {
    await interfaces.wafersWithControlInterface
      .details(id)
      .then((res) => {
        setOpen({ 
          data: res.data 
        })
      })
  }

  function openRemoveDialog(e, id) {
    e.stopPropagation()
    openRemove({ id: id })
  }

  const actions = (file) => {
    return (
      <div style={{ display: "flex", marginLeft: "0.3rem" }}>
        <Tooltip title="Eliminar">
          <IconButton
            onClick={(e) => openRemoveDialog(e, file.id)}
            size={windowSize ? "medium" : "normal"}
            disabled={!data.permissions.managementInterface}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </div>
    )
  }

  const handleDelete = async () => {
   const id = remove.id
    setLoading(true)
    await interfaces.wafersWithControlInterface
      .deleteVeh(id)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: "success",
        })
        setRender(!render)
      })
      .catch((err) => {
        createDismissableSnackbar("Algo salió mal!", {
          variant: "error",
        })
      })
    setLoading(false)
    closeRemove()
    setClose()
  }

  const RowsTransit = () =>
    data.rows.map((file) => [
      file.fecha_creacion,
      file.dominio,
      file.marca,
      file.modelo,
      "",
      "",
      file.estado,
      file.usuario_controlador,
      file.fecha_finalizacion,
      actions(file),
      ""
    ])

  let columns = [
    {
      name: "fecha_creacion",
      label: "Fecha de carga",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "dominio",
      label: "Dominio",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "marca",
      label: "Marca",
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: "custom",
        filterName: "marca",
        filterOptions: {
            display: (filterList, onChange, index, column) => {
              if (Object.keys(data.filters).length > 0) {
                return (
                  <AutocompleteFilter
                    filterList={filterList}
                    onChange={onChange}
                    index={index}
                    column={column}
                    label={"Marca"}
                    filterName={"marca"}
                    options={data.filters.marca}
                    fullWidth={true}
                  />
                )
              }
            },
        },
      },
    },
    {
      name: "modelo",
      label: "Modelo",
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: "custom",
        filterName: "modelo",
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(data.filters).length > 0) {
              const filteredP = data.filters.marca.filter(name => name.marca === filterList[2]?.[0])
              const provinciaId = filteredP.length > 0 ? filteredP[0].id : null
              const filteredC = provinciaId 
                ? data.filters.modelo.filter(item => item.marca_id === provinciaId) 
                : []
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label={"Modelo"}
                  filterName={"modelo"}
                  options={filteredC}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    }, 
    {
      name: "fecha_desde",
      label: "Desde",
      options: {
        filter: true,
        sort: false,
        display: false,
        filterType: "custom",
        filterOptions: {
          display: (filterList, onChange, index, column) => {
              return (
                <DateFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label={"Desde"}
                  selectedDate={filterList[index][0] ? moment(filterList[index][0], "DD/MM/YYYY").toDate() : null}
                  handleDateChange={(date) => onChange([moment(date).format("DD/MM/YYYY")], index, column)}
                />
              )
            
          },
        },        
      },
    },
    {
      name: "fecha_hasta",
      label: "Hasta",
      options: {
        filter: true,
        sort: false,
        display: false,
        filterType: "custom",
        filterOptions: {
          display: (filterList, onChange, index, column) => {
              return (
                <DateFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label={"Hasta"}
                  selectedDate={filterList[index][0] ? moment(filterList[index][0], "DD/MM/YYYY").toDate() : null}
                  handleDateChange={(date) => onChange([moment(date).format("DD/MM/YYYY")], index, column)}
                />
              )
            
          },
        },     
      },
    },
    {
      name: "estado",
      label: "Estado",
      options: {
        filter: true,
        sort: false,
        sortThirdClickReset: true,
        filterType: "custom",
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(data.filters).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label={"Estado"}
                  filterName={"estado"}
                  options={ESTADO_VEH}
                  defaultOption={data.permissions.managementInterface ? { estado: "Revisión finalizada" } : { estado: "Pendiente de revisión" }}
                 // style={{width: '200px', paddingRight: '100px'}}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: "usuario_controlador_id",
      label: "Usuario controlador",
      options: {
        filter: true,
        sort: false,
        display: true,
        sortThirdClickReset: true,
        filterType: "custom",
        filterOptions: {
          display: (filterList, onChange, index, column) => {
            if (Object.keys(data.filters).length > 0) {
              return (
                <AutocompleteFilter
                  filterList={filterList}
                  onChange={onChange}
                  index={index}
                  column={column}
                  label={"Usuario controlador"}
                  filterName={"fullName"}
                  options={ data.permissions.managementInterface ? data.filters.usuario_controlador : []}
                  fullWidth={true}
                />
              )
            }
          },
        },
      },
    },
    {
      name: "fecha_finalizacion",
      label: "Fecha finalización",
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "",
      label: "",
      options: {
        filter: false,
        sort: false,
      },
    }
  ]

  return (
    <>
      {state.suspense && (
        <EditContextProvider>
            <Edit
              open={state.open}
              handleclose={setClose}
              data={state.data}
              setRender={setRender}
              render={render}
              setLoading={setLoading}
              //setOpen={setOpen}
              setData={setData}
              dataBefore={data.permissions}
            />
        </EditContextProvider>
      )}

      <MuiDatables
        columns={columns}
        data={RowsTransit()}
        title={`Total de vehículos con obleas a controlar: ${data.rows.length}`}
        apiCall={apiCall}
        count={data.header}
        render={render}
        setRender={setRender}
        textPlaceholder="Buscar por dominio o nº de v..."
        onRowClick={(_, index) => vehInfo(data.rows[index.dataIndex].id)}
        padding={windowSize ? "10px" : ""}       
      />

      {remove.suspense && (
        <DialogComponent
          open={remove.open}
          title="¿Desea eliminar este vehículo?"
          handleclose={closeRemove}
          widthLarge={"500px"}
          maxHeight
          disableBackdropClick
          disableEscapeKeyDown
          actions={
            <CancelConfirmButtons
              onClickCancel={closeRemove}
              onClickSubmit={handleDelete}
              isLoading={loading}
              disabledSubmit={loading}
            />
          }
        />
      )}
    </>
  )
}
export default WafersWithControlTable